import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private api: ApiService) { }

  getAllInvoice(data: any): Observable<any> {
    return this.api.post(environment.getAllInvoice, data);
  }

  updateInvoice(data: any): Observable<any> {
    return this.api.post(environment.updateInvoice, data);
  }

  createInvoice(data: any): Observable<any> {
    return this.api.post(environment.createInvoice, data);
  }
  
  deleteInvoice(data: any): Observable<any> {
    return this.api.post(environment.deleteInvoice, data);
  }

  getInvoiceAnalytics(data: any): Observable<any> {
    return this.api.post(environment.getInvoiceAnalytics, data);
  }

  sendInvoice(data: any): Observable<any> {
    return this.api.post(environment.sendInvoice, data);
  }

  generateInvoice(data: any): Observable<any> {
    return this.api.post(environment.generateInvoice, data);
  }
}
